export default "__VITE_ASSET__634bca41__"